import { useRef, useState } from "react";

export function useObjectState(defaultState = {}) {
    const stateRef = useRef({ ...defaultState }) // Use a ref so a set never uses an out of date state (from other set called in the meantime)
    const [state, setState] = useState(stateRef.current)

    const newSetState = state => {
        for (const key in stateRef.current) delete stateRef.current[key]
        for (const key in state) stateRef.current[key] = state[key]
        setState({ ...stateRef.current })
    }
    const setProperty = key => value => {
        stateRef.current[key] = value
        setState({ ...stateRef.current })
    }
    return [state, newSetState, setProperty]
}